import { render, staticRenderFns } from "./OrderItem.vue?vue&type=template&id=57ea0462&scoped=true&"
import script from "./OrderItem.vue?vue&type=script&lang=js&"
export * from "./OrderItem.vue?vue&type=script&lang=js&"
import style0 from "./OrderItem.vue?vue&type=style&index=0&id=57ea0462&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ea0462",
  null
  
)

export default component.exports